Object.defineProperty(SVGElement.prototype, 'innerHTML', {
  get: function() {
    var $child, $node, $temp, _i, _len, _ref;
    $temp = document.createElement('div');
    $node = this.cloneNode(true);
    _ref = $node.children;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      $child = _ref[_i];
      if ($child && $child.nodeType && $child.nodeType == 1) {
        $temp.appendChild($child);
      }
    }
    return $temp.innerHTML;
  },
  set: function(markup) {
    while (this.firstChild) {
      this.firstChild.parentNode.removeChild(this.firstChild);
    }
    markup = "<svg>" + markup + "</svg>";
    var $div = document.createElement('div');
    $div.innerHTML = markup;
    var child = $div.firstChild;
    while (child.firstChild) {
      this.appendChild(child.firstChild);
    }
  },
  enumerable: false,
  configurable: true
});



//////////////////
// WEBPACK FOOTER
// ./src/components/metro-browser/src/scripts/innersvg-polyfill.js
// module id = 376
// module chunks = 0